import Layout from '@/layout'

const SystemClearingRouter = {
  path: '/Clearing',
  component: Layout,
  redirect: 'noredirect',
  name: 'Clearing',
  meta: {
    title: '结算',
    icon: 'daohang-ziliaoguanli'
    // roles: ['subsystem']
  },
  children: [
    {
      path: 'FinanceManage',
      component: () => import('@/views/cargo/v0/Clearing/financeManage'),
      name: 'FinanceManage',
      meta: { title: '财务审核' },
      props: true,
      roles: []
    }, {
      path: 'FinanceChargeSearch',
      component: () => import('@/views/cargo/v0/Clearing/financeChargeSearch'),
      name: 'FinanceChargeSearch',
      meta: { title: '财务综合查询' },
      props: true,
      roles: []
    },
    {
      path: 'BillingNative',
      component: () => import('@/views/cargo/v0/Clearing/billingNative'),
      name: 'BillingNative',
      meta: { title: '对账新版' },
      roles: ['module_fmBillingNative']
    },
    {
      path: 'AutomaticReconciliation',
      component: () => import('@/views/cargo/v0/Clearing/AutomaticReconciliation/index'),
      name: 'AutomaticReconciliation',
      meta: { title: '自动对账' },
      roles: []
    },
    {
      path: 'AIReconciliation',
      component: () => import('@/views/cargo/v0/Clearing/AIReconciliation/index'),
      name: 'AIReconciliation',
      meta: { title: 'AI对账' },
      roles: ['module_AIReconciliation']
    },
    {
      path: 'MakeInvoice',
      component: () => import('@/views/cargo/v0/Clearing/makeInvoice'),
      name: 'MakeInvoice',
      meta: { title: '开票' },
      roles: ['module_ACMakeInvoice']
    },
    {
      path: 'WriteOff',
      component: () => import('@/views/cargo/v0/Clearing/writeOff'),
      name: 'WriteOff',
      meta: { title: '销账' },
      roles: []
    },
    {
      path: 'BillPayment',
      component: () => import('@/views/cargo/v0/Clearing/billPayment'),
      name: 'BillPayment',
      meta: { title: '付款申请' },
      roles: ['module_ACPayAuth']
    },
    {
      path: 'BillPayment/SR',
      component: () => import('@/views/cargo/v0/Clearing/components/BillPayment/siRui/billPayment'),
      name: 'BillPaymentOfSiRui',
      meta: { title: '付款申请-云平台' },
      roles: ['module_ACPayAuthSR']
    },
    {
      path: 'BillPaymentJc',
      component: () => import('@/views/cargo/v0/Clearing/billPaymentJc'),
      name: 'BillPaymentJc',
      meta: { title: '付款申请-H5' },
      roles: ['module_ACPayAuthH5']
    },
    {
      path: 'ClRealSendReceive',
      component: () => import('@/views/cargo/v0/Clearing/clRealSendReceive'),
      name: 'ClRealSendReceive',
      meta: { title: '实收实付' },
      roles: []
    },
    {
      path: 'BillPaymentByJob',
      component: () => import('@/views/cargo/v0/Clearing/billPaymentByJob'),
      name: 'BillPaymentByJob',
      meta: { title: '付款申请-业务' },
      roles: ['module_fmBillPaymentByJob']
    },
    {
      path: 'InvoiceNo',
      component: () => import('@/views/cargo/v0/Clearing/invoiceNo'),
      name: 'InvoiceNo',
      meta: { title: '发票号管理' },
      roles: ['module_fmInvoiceNo']
    },
    {
      path: 'MTCloseAccount',
      component: () => import('@/views/cargo/v0/Clearing/mtCloseAccount'),
      name: 'MTCloseAccount',
      meta: { title: '关账' },
      roles: ['module_MTCloseAccount']
    },
    {
      path: 'ImportCharge',
      component: () => import('@/views/cargo/v0/Clearing/ImportCharge/index'),
      name: 'ImportCharge',
      meta: { title: '批量导入费用(财务)' },
      roles: []
    },
    {
      path: 'DocumentCirculation',
      component: () => import('@/views/cargo/v0/Clearing/documentCirculation'),
      name: 'DocumentCirculation',
      meta: { title: '单证流转' },
      roles: ['module_fmFile']
    },
    {
      path: 'FmSingleRelease',
      component: () => import('@/views/cargo/v0/Clearing/fmSingleRelease'),
      name: 'FmSingleRelease',
      meta: { title: '主单放单管理' },
      roles: ['module_fmSingleRelease']
    },
    {
      path: 'FmHBLSingleRelease',
      component: () => import('@/views/cargo/v0/Clearing/fmHBLSingleRelease'),
      name: 'FmHBLSingleRelease',
      meta: { title: '分单放单管理' },
      roles: ['module_fmHBLSingleRelease']
    },
    {
      path: 'ReleaseManagement',
      component: () => import('@/views/cargo/v0/Clearing/ReleaseManagement/index'),
      name: 'FmHBLSingleRelease',
      meta: { title: '放单管理' },
      roles: ['module_ReleaseManagement']
    },
    {
      path: 'ChangeChargeVerify',
      component: () => import('@/views/cargo/v0/Clearing/changeChargeVerify'),
      name: 'ChangeChargeVerify',
      meta: { title: '更改费用审核' },
      roles: ['module_ChangeChargeVerify']
    },
    {
      path: 'ChangeChargeVerifyBpm',
      component: () => import('@/views/cargo/v0/Clearing/changeChargeVerifyBpm'),
      name: 'ChangeChargeVerifyBpm',
      meta: { title: '更改费用审核（新版）' },
      roles: ['module_ChangeChargeVerifyBpm']
    },
    {
      path: 'RuleEngineSetup',
      component: () => import('@/views/cargo/v0/Clearing/ruleEngineSetup'),
      name: 'RuleEngineSetup',
      meta: { title: '对账规则引擎设置' },
      roles: ['module_RuleEngineSetup']
    },
    {
      path: 'FmBankSlip',
      component: () => import('@/views/cargo/v0/Clearing/fmBankSlip'),
      name: 'FmBankSlip',
      meta: { title: '水单认领' },
      roles: ['module_FmBankSlip']
    },
    {
      path: 'ClosingAccount',
      component: () => import('@/views/cargo/v0/Clearing/closingAccount'),
      name: 'ClosingAccount',
      meta: { title: '结转' },
      roles: ['module_ClosingAccount']
    },
    {
      path: 'BillOverseasSCenter',
      component: () => import('@/views/cargo/v0/Clearing/BillOverseasSCenter/index'),
      name: 'BillOverseasSCenter',
      meta: { title: '海外结算中心' },
      roles: ['module_BillOverseasSCenter']
    },
    {
      path: 'OcPayment',
      component: () => import('@/views/cargo/v0/Clearing/ocPayment'),
      name: 'OcPayment',
      meta: { title: '查询线下收款信息' },
      roles: ['module_OcPayment']
    },
    {
      path: 'BillPaymentBpm',
      component: () => import('@/views/cargo/v0/Clearing/billPaymentBpm'),
      name: 'billPaymentBpm',
      meta: { title: '付款申请（新版）' },
      roles: ['module_ACPayAuthBpm']
    },
    {
      path: 'SharedCenter',
      component: () => import('@/views/cargo/v0/Clearing/sharedCenter'),
      name: 'sharedCenter',
      meta: { title: '共享中心' },
      roles: ['module_SharedCenter']
    }, {
      path: 'ChargeConfirmed',
      component: () => import('@/views/cargo/v0/Clearing/chargeConfirmed'),
      name: 'chargeConfirmed',
      meta: { title: '待确认费用' },
      roles: ['module_ChargeConfirmed']
    },
    {
      path: 'AdvancePayment',
      component: () => import('@/views/cargo/v0/Clearing/advancePayment'),
      name: 'AdvancePayment',
      meta: { title: '预付款客户管理' },
      roles: ['module_AdvancePayment']
    },
    {
      path: 'ImportChargeAllBusiness',
      component: () => import('@/views/cargo/v0/Clearing/ImportChargeAllBusiness/index'),
      name: 'ImportChargeAllBusiness',
      meta: { title: '批量导入费用(全业务)' },
      roles: ['module_ImportChargeAllBusiness']
    },
    {
      path: 'InvoicePool',
      component: () => import('@/views/cargo/v0/Clearing/invoicePool'),
      name: 'invoicePool',
      meta: { title: '发票池' },
      roles: ['module_InvoicePool']
    }
  ]
}

export default SystemClearingRouter
